import React from 'react';
import './Formulaire.css';
import vid5 from '../../asserts/images/vid52.mp4';
import logo from '../../asserts/images/logo.png';
import { Link } from 'react-router-dom';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Ripple, initMDB } from 'mdb-ui-kit';
initMDB({ Ripple });

const Formulaire = (props) => {
  return (
    <div className="video-background">
      <video autoPlay loop muted>
        <source src={process.env.PUBLIC_URL + vid5} type="video/mp4" />
      </video>
      <div className="body">
      <div className="wrapper">
    <form action="#">
      <div style={{marginTop:'-40px'}}>
      <Link to="/"><img src={logo} style={{ width: '135px', height: 'auto' }} alt="logo" /></Link>
      <h2 className='TITREH2'>CONNEXION</h2>
      </div>
        <div className="input-field">
        <input type="text" required/>
        <label>Entrer votre email</label>
      </div>
      <div className="input-field">
        <input type="password" required/>
        <label>Entrer votre mot de passe</label>
      </div>
      <div className="forget">
        <a href="#">Mot de passe oublié ?</a>
      </div>
      <Link to="/Espaceetudiant"><button type="submit" >
      <i className="fa-solid fa-right-to-bracket" style={{paddingRight:'20px'}}></i>       
         Connecter
       </button>  
       </Link> 
    </form>
  </div>
      </div>
 <div>
 <footer className="text-center bg-body-tertiary">
    <div style={{ backdropFilter: 'blur(9px)', WebkitBackdropFilter: 'blur(9px)', marginTop: '-60px', position: 'relative', height: '70px' }}>
        <div className="container pt-4">
          <section className="mb-4 d-flex justify-content-between align-items-center">
            {/* Text */}
            <div className="text-left text-white" style={{ marginTop: '-22px' }}>
              <p style={{ margin: '0' }}>
                © 2024 ISIMM Monastir. All rights reserved.
              </p>
            </div>
            {/* Icons */}
            <div className="d-flex align-items-center" style={{ marginTop: '-22px' }}>
              {/* Facebook */}
              <a
                data-mdb-ripple-init
                className="btn text-white btn-floating m-1 btn-lg rounded-circle"
                href="#!"
                role="button"
                style={{ backgroundColor: '#3b5998' }}
              >
                <i className="fab fa-facebook-f rounded-circle"></i>
              </a>

              {/* Mail */}
              <a
                data-mdb-ripple-init
                className="btn text-white btn-floating m-1 btn-lg rounded-circle"
                href="mailto:your-email@example.com"
                role="button"
                style={{ backgroundColor: '#dd4b39' }}
              >
                <FontAwesomeIcon icon={faEnvelope} className="rounded-circle" />
              </a>

              {/* Linkedin */}
              <a
                data-mdb-ripple-init
                className="btn text-white btn-floating m-1 btn-lg rounded-circle"
                style={{ backgroundColor: '#0082ca' }}
                href="#!"
                role="button"
              >
                <i className="fab fa-linkedin-in rounded-circle"></i>
              </a>
            </div>
          </section>
        </div>
      </div>
    </footer>
 </div>

    </div>
  );
};

export default Formulaire;